import { FirebaseDocRefType, FirebaseDocumentDataType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { fetchStocksAction } from 'reducks/stock/actions'
import { mergeStocks } from 'reducks/stock/operations'

const fetchDailyStocks = (date: string, storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const manufacturerRef = getState().auth.manufacturer_ref
    let query = storeRef
      .collection('store_stocks')
      .where('date', '==', date)
      .where('type', '==', 'daily')
      .where('stock', '>=', 1)
    if (typeof manufacturerRef !== 'undefined') {
      query = query.where('manufacturer_ref', '==', manufacturerRef)
    }
    // 在庫数が1以上の当日取り置き商品を取得する
    const stocks = await query
      .get()
      .then((snapshots: FirebaseDocumentDataType) => {
        return mergeStocks(snapshots)
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    dispatch(fetchStocksAction(stocks))
  }
}

export default fetchDailyStocks
